import { Grid } from '@mui/material'
import React from 'react'
import { getDateInFormat } from '../../Helpers/Util'
import { ChipButton } from '../Shared'
import CONSTANTS from '../../Constants'

const DetailPageRowChip = ({
  name = '',
  value = '',
  isDate = false,
  isStatus = false,
  truncate = true,
}: any) => {
  let displayValue: string

  if (!isDate) {
    if (truncate && value.length > 40) {
      displayValue = `${value.substring(0, 40)}...`
    } else {
      displayValue = value
    }
  } else {
    displayValue = getDateInFormat(value ?? '', CONSTANTS.DATE_FORMAT_TIME_SECONDS)
  }

  const displayChipButton = (type?: string) => {
    const chipButtonType = type?.toUpperCase() === 'INACTIVE' ? 'secondary' : 'success'
    const chipButtonLabel = type?.toUpperCase() === 'INACTIVE' ? 'In Active' : 'Active'

    return (
      <div className='sub-heading-6 view__role-list  text-left col36 word-wrap'>
        <ChipButton type={chipButtonType} label={chipButtonLabel} style={{ padding: '0px 8px' }} />
      </div>
    )
  }
  return (
    <Grid container>
      {name && (
        <Grid item xs={6} md={3}>
          <div className='sub-heading-6 view__role-list  text-left col34'>{name}</div>
        </Grid>
      )}
      <Grid item xs={6} md={9}>
        {isStatus ? (
          <>
            {value.toUpperCase() === 'ACTIVE' && displayChipButton()}
            {value.toUpperCase() === 'INACTIVE' && displayChipButton('inactive')}
          </>
        ) : (
          <div className='sub-heading-6 view__role-list  text-left col36 word-wrap'>
            {displayValue}
          </div>
        )}
      </Grid>
    </Grid>
  )
}
export default React.memo(DetailPageRowChip)
